import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE__INIT_INSTALLERS':
            return core.setInstallers(state, action.installers);
        case 'FHE__SET_INSTALLERDETAILS':
            return core.setInstallerDetails(state, action.installer);
        case 'FHE__UPDATE_INSTALLER':
            return core.updateInstallerDetails(state, action.installer);
        case 'FHE__ADD_INSTALLER':
            return core.addInstaller(state, action.installerId, action.installer);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Installers/reducer.js